module.exports = __webpack_public_path__ + "img/01.aabd2355.png";